import { TextInput } from '@mgmresorts/mgm-ui';
import React, { useContext, useMemo } from 'react';

import { useContent } from '../../../hooks/useContent';
import { MaxLengths } from '../../../utils/constants';
import { SignUpFormContext } from '../SignUpFormContext';
import { useFieldErrorAnalytics } from '../useFieldErrorAnalytics';

export function FirstName() {
  const { bindFirstName, isLoading, invalidFields } = useContext(SignUpFormContext);
  const { getContentByPath } = useContent();
  useFieldErrorAnalytics({ field: 'firstName', invalidFields });

  const error = useMemo(
    (): string | undefined =>
      invalidFields.includes('firstName') ? getContentByPath('accountCreation.fields.firstName.error') : undefined,
    [getContentByPath, invalidFields],
  );

  return (
    <TextInput
      variant='default'
      label={getContentByPath('accountCreation.fields.firstName.title')}
      id='firstName'
      testId='firstName'
      disabled={isLoading}
      error={!!error}
      hint={error}
      {...bindFirstName}
      maxLength={MaxLengths.FirstName}
      autoComplete='given-name'
    />
  );
}

FirstName.displayName = 'FirstNameField';
